module.exports = __webpack_public_path__ + "img/Deathknight-undead-f-70.ef2624f6.gif";